/**
 * @desc 列表
 */
const URL = "/rantion-bus";
import http, { updateResponse } from "@/http";
export function request(params: API.bus.requestRecordLog.list.Params, options?: any) {
  return updateResponse(
    http(URL + `/requestRecordLog/list`, {
      method: "GET",
      params,

      ...options,
    }),
  );
}
